import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss', '../platform.component.scss']
})
export class PrivacyComponent implements OnInit {

  mode: number = 0;
  constructor(
      private router: Router,
    ) { 
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(() => {
        setTimeout(() => {
          const jumpTop = document.getElementById('jump-top');
          if (jumpTop) {
            jumpTop.scrollIntoView({ behavior: 'smooth' });
          }
        }, 10);
      });
    }

  ngOnInit(): void {
  }
  toggleContact() {
  }
  moveContact() {
    this.router.navigate(["pages/platform/contact"]);
  }
  getManualSchool() {
    window.open("")
  }
  getManualSupport() {
    window.open("f")
  }
}
